import React from 'react';
import Card from 'lib/components/Card/Card';
import { ReportHeader } from '../components/ReportHeader';

export function AccountingTab() {
  return (
    <Card>
      <ReportHeader title="Accounting" />
      <div className="p-6">{/* Accounting content goes here */}</div>
    </Card>
  );
}
